export const getFirstArrayStringValueOrStringValue = (
  value: unknown,
): string | undefined => {
  if (value !== undefined && value !== null) {
    if (Array.isArray(value)) {
      if (typeof value[0] === 'string') {
        return value[0];
      }
    } else {
      if (typeof value === 'string') {
        return value;
      }
    }
  }

  return undefined;
};
